import inventoryLocations from './inventory-locations';
import orderHistory from './order-history';

export default {
    inventoryLocations,
    orderHistory,
};
